// Ustawienie rodzica: czy bot ma się odzywać w zadaniach (reakcje po próbach, pytania dziecka, komentarz na koniec lekcji; SPEC §14.5).
// Zapisane tylko w tej przeglądarce. Bez zapisu obowiązuje wartość domyślna z konfiguracji.
import { config } from '../config.ts';
import type { StorageLike } from './attemptLog.ts';

export const COACH_KEY = 'naative.coach.v1';

export interface CoachSettings {
  enabled(): boolean;
  set(on: boolean): void;
}

export function createCoachSettings(store: StorageLike | null, fallback: boolean = config.coach.enabledByDefault): CoachSettings {
  return {
    enabled() {
      try {
        const raw = store?.getItem(COACH_KEY);
        if (raw) {
          const v = (JSON.parse(raw) as { on?: unknown }).on;
          if (typeof v === 'boolean') return v;
        }
      } catch {
        /* uszkodzony zapis albo brak dostępu do pamięci — wartość domyślna */
      }
      return fallback;
    },
    set(on) {
      try {
        store?.setItem(COACH_KEY, JSON.stringify({ on }));
      } catch {
        /* bez pamięci ustawienie nie przetrwa odświeżenia — nic się nie psuje */
      }
    },
  };
}
